// ----- Handles the address retrieval for address lookup and previous address in the checkout.

var instances = {};

function initialise(context) {
    // Instance id.
    // let id = generateId(); 

    // Get instance id.
    let id = context.attr(expressSelectors()['lookups']['instance']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['lookups']['instance'], generateId());
        id = context.attr(expressSelectors()['lookups']['instance']);
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Lookups: Instance already initialised skipping.");
        }
        return false;
    }

    // This is the container that contains form fields that will get serialised and added to the payload of the callback, this has historically also been used as the response container before we have data-callback-container-id.
    let content = context.attr(expressSelectors()['lookups']['ajax-content']);
    // Should we be ignoring form data inside of the data-ajax-context ( i.e response container )
    let ignoreFormData = context.attr(expressSelectors()['lookups']['ignore-form-data']);
    if (ignoreFormData == undefined) {
        // If the lookup does not specifically reference a content container to update ( e.g. postcode lookup fields ), then do not serialise nested inputs, as doing this prematurely can cause reusable cards to be removed unintentially.
        if (content == undefined) {
            ignoreFormData = true;
        } else {
            ignoreFormData = false;
        }
    } else {
        ignoreFormData = true;
    }
    // Get element context.
    if (content) {
        content = $('#' + content);
    } else {
        // Attempt fallback.
        content = $('#' + context.parents('[' + expressSelectors()['lookups']['ajax-content'] + ']').attr(expressSelectors()['lookups']['ajax-content']));
        // Attempt to fallback on last time to callback container.
        if (content.length == 0) {
            content = getResponseCallbackContainer(context);
        }
    }
    // Get input.
    let input = $('#' + context.data('ajax-include'));
    // Fallback to context if not input is defined.
    if (input.length == 0) {
        input = context;
    }

    // Added key attribute ( used for identifying the callback container after callback )
    input.attr(expressSelectors()['lookups']['lookup-key'], '');

    // Is validation enabled?
    let abideEnabled = AXISInputs.isAbideEnabled(context);
    
    // Added instance id to the content container.
    // AJAX Url.
    let postUrl = context.attr('data-ajax');
    if  (!postUrl) {
        // postUrl = context.parents('form').attr('data-ajax');
        postUrl = context.parents('[data-ajax]').attr('data-ajax');
    }
    if (!postUrl) {
        AXISDebug.output(3,"AJAX Lookups: Failed to initialise, no callback Url defined.");
        return false;
    }

    // Create new instance
    instances[id] = {};
    // Add instance properties.
    instances[id]['content'] = content;
    // Add input.
    instances[id]['ajax-include'] = input;
    // Add AJAX URL.
    instances[id]['post-url'] = postUrl;
    // Store context.
    instances[id]['context'] = context;
    // Store whether validation is enabled.
    instances[id]['abide-enabled'] = abideEnabled;
    
    instances[id]['ignore-form-data'] = ignoreFormData;

    context.on((context.is('button') ? 'click' : 'change') + ' do-lookup', function(event) {
        // Prevent default behavour i.e form submission.
        event.preventDefault();
        // Check whether this is a confirm button.
        let confirm = context.attr(expressSelectors()['modals']['confirm'])
        // Check if a form modal is attached.
        if (confirm == undefined) {
            confirm = context.data('modal-form');
        }
        // Check whether button is disabled.
        let isDisabled = context.hasClass("disabled");
        if (isDisabled) {
            if (AXISDebug.level() >= 2) {
                AXISDebug.output(2, "Lookups: Button disabled cancelling callback.");
            }
            return false;
        }
        // Check validation.
        let isValid = (abideEnabled ? AXISInputs.validateInput(input, true) : null);
        let validationOutput = (abideEnabled ? AXISInputs.validationOutput2(input, isValid) : null);
        // If no input has been defined then focus in on form input.
        if ((abideEnabled) && isValid == null) {
            input.trigger('focus');
            context.parents('form').foundation('addErrorClasses', input, ['vm-validate']);
        }
        if ((abideEnabled) && (isValid)) {
            if (confirm) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1, "AJAX: This button requires confirmation before performing callback")
                }
                // Get confirmation modal id.
                let modal = context.attr(expressSelectors()['modals']['confirm'])
                // Find the modal.
                modal = $('[data-modal=' + modal + ']');
                // Find proceed button.
                let proceedButton = modal.find('.prompt-proceed-button');
                // Modified to only fire once modal has been accepted not as soon as the user click the button.
                proceedButton.on('modal-accepted', function(event) {
                    // Prevent default behavour.
                    event.preventDefault();
                    // Prevent any bubbling and to prevent any other click event listeners ( i.e in the modal confirm ) from pre-maturely firing causing duplicate callbacks.
                    event.stopImmediatePropagation();
                    // Remove listener.
                    proceedButton.off('modal-accepted');
                    // Perform callback
                    let post = callback(id).catch((error) => {
                        AXISDebug.output(3,"Lookups: " + error);
                    });
                    // If retrieval fails.
                    if (!post) {
                        callouts.create(post,2);
                    }
                });
            } else {
                // Perform lookup.
                let post = callback(id).catch((error) => {
                    console.error(error);
                    //AXISDebug.output(2,"Lookups: ",error);
                });
                // If retrieval fails.
                if (!post) {
                    callouts.create(post,2);
                }
            }
        } else if (!abideEnabled) {
            if (confirm && context.attr(expressSelectors()['modals']['confirmed'])) {
                // Perform lookup.
                let post = callback(id).catch((error) => {
                    AXISDebug.output(2,"Lookups: " + error);
                });
            } else if (confirm == undefined) {
                // Perform lookup.
                let post = callback(id).catch((error) => {
                    AXISDebug.output(2,"Lookups: " + error);
                });
            }
            
        }
    });

    input.on('keydown', function(event) {
        if (event.key == "Enter") {
            // Prevent form from submitting as we just want to do a lookup callback.
            event.preventDefault();
            // trigger a callback.
            context.trigger('click');
        }
    });
}   

function callback(instanceId) {
    let addressRetrievalPromise = new Promise((resolve, reject) => {
        // Custom config for callback mechanism due to the complexity on putting together operation and custom value pair.
        let customConfig = {};
        // Get input context.
        let input = instances[instanceId]['ajax-include'];
        if (!input) {
            input = instances[instanceId]['context'];
        }
        // Lookup context.
        let context = instances[instanceId]['context'];
        // Get operation from context first as that is consistent with how we normally get the opertation then if that fails then get the operation from input.
        let operation = AXISAjax.getOperation(context);
        // Fallback.
        if (!operation) {
            operation = AXISAjax.getOperation(input);
        }
        // Fallback #3 travel up the DOM.
        if (!operation) {
            // Fallback to parent operation.
            let parentOperation = context.parents('[' + expressSelectors()['ajax']['operation'] + ']');
            if (parentOperation) {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Lookups: A parent element has an operation defined so using that.");
                }
                operation = AXISAjax.getOperation(parentOperation);
            }
        }

        if (!operation) {
            operation = "";
        }

        // If operation exists then add it to the custom config.
        if (operation) {
            customConfig['operation'] = operation;
        }

        let customValue = AXISAjax.getCustomNameValuePair(context);
        // Fallback to key.
        if (!customValue) {
            customValue = AXISAjax.getCustomNameValuePair(input);
        }

        // If custom value pair exists then add it to the custom config.
        if (customValue) {
            customConfig['custom-name-pair'] = customValue;
        }

        // Get postback url.
        let postUrl = instances[instanceId]['post-url'];
        // Add post url to custom config.
        if (postUrl) {
            customConfig['url'] = postUrl;
        }
        // Get call back content fields.
        let fieldInputs = instances[instanceId]['content'];
        // Check the ajax context container for any inputs that can be serialised and added to the payload.
        if (fieldInputs) {
            // Serialize all values.
            // You will run into issues here if there are multiple ajax-lookups in the callback content.
            // Check whether the input that did the lookup is inside of the fieldInputs.
            // IMPORTANT: Suppressing as this will causing issues with postcode lookups due to nested lookups.
            //let containsAJaxTriggers = fieldInputs.find($(expressSelectors()['lookups']['initialise'])).length > 0;

            let fieldValues = "";
            // Should we be ignoring form data inside of the data-ajax-context ( i.e response container )
            const ignoreFormData = instances[instanceId]['ignore-form-data'];
            // Changing this logic as its creates a bug where when doing a postcode lookup a secondary lookup gets returned in the response which then creates the scenario where the fields don't get serialised when we just need to ignore other lookup's as this could reset the flow.
            if (fieldInputs.length && !ignoreFormData) {
                fieldValues = fieldInputs.find('input, select').not($(expressSelectors()['lookups']['initialise'])).serialize();
                if (fieldValues.length) {
                    // Add the data to the custom data string config parameter.
                    customConfig['custom-data-string'] = fieldValues;
                }
            }
        }
        // Do post back.
        AXISAjax.callback((input ? input : context), customConfig).then((data) => {   
            // Get response.
            let response = data['data']; 
            // Check if there is actually some content in the response to update.
            if (response.length > 0) {
                 // Store the container where the new content get outputted to.
                let responseContainer = instances[instanceId]['content'];
                if (responseContainer.length > 0) {
                    // output new markup.
                    responseContainer.html(response);
                } else {
                    // Fallback, try one more time for the callback container.
                    let callbackContainer = AXISAjax.getCallbackContainer(context);
                    if (responseContainer.length > 0 || callbackContainer.length > 0) {
                        callbackContainer.html(response);
                    } else {
                        reject("Failed to inject response into DOM due not being able to find response container.");
                        return false;
                    }
                }
            }
           
            resolve(true);
        }).catch((error) => reject(error));
    });
    return addressRetrievalPromise;
}

function lookupInitialiseAll() {
    AXISDebug.output(1,"AJAX lookups: Attempting to initialise ALL lookups on the page.");
    let triggers = $(expressSelectors()['lookups']['initialise']);
    if (triggers.length > 0) {
        triggers.each(function() {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(1,"AJAX lookups: A lookup has been found attempting to initalise.");
            }
            let context = $(this);
            initialise(context);
        });
        return true;
    }
} 

function getLookupKey(context) {
    if (context == undefined) {
        AXISDebug.output(3, "AJAX Lookups: You must provide your current context to be able to find the matching lookup key.");
        return false;
    }
    // Then the current context is within a lookup content.
    if (context.parents('.lookup-content').length > 0) {
        // Get the lookup id.
        let lookup = context.parents('.lookup-content').attr('id');
        // Get lookup context.
        lookup = $('[' + expressSelectors()['lookups']['ajax-content'] +'="' + lookup + '"]');
        // Get key context.
        let key = lookup.attr('data-ajax-include');
        key = $('#' + key);
        return key;
    } else if (context.attr(expressSelectors()['lookups']['lookup-key']) != undefined) {
        return context.attr('id');
    }
}

var AXISLookups = $.AXISLookups = {
    initialiseAll: (version) => {
        // There is a high chance we will be implmenting a new version but will need to keep support for the old hence the version var.
        if (version == 1) {
            return lookupInitialiseAll();
        } else {
            AXISDebug.output(3,"Please define a version");
            return false;
        }
    },
    initialise: (context) => {
      return initialise(context);
    },
    getLookupKey: (context) => {
        return getLookupKey(context);
    }

}

export { AXISLookups }